export default {
  searchHistory: [],
  filterHistory: [],
  cartCache: false
}
